<app-header></app-header>
<div class="forgot_container">
    <app-background></app-background>
    <div class="forgot_details_card mat-elevation-z4" *ngIf="enteremail">
        <div class="forgot_details_email_card">
            <div class="forgot_details_header">Sign Up with Email</div>
            <div class="forgot_details_header_details">Enter the email address associated with your account.</div>
            <div>
                <mat-form-field appearance="outline" class="forgot_form_fields">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Email" type="text" [formControl]="Email"
                        style="vertical-align: top; margin-left: 5px;">
                    <mat-icon matSuffix style="color: var(--black-shade); margin-right: 5px; vertical-align: top;">email</mat-icon>
                    <mat-error *ngIf="!Email.valid">
                        {{getEmailError()}}
                    </mat-error>
                </mat-form-field>
            </div>
            
            <div class="forgot_button" style="text-align: center;padding-bottom: 10px;">
                <button class="forgot_button_details" (click)="emailiscorrect()" type="submit">Send</button>
            </div>
        </div>
    </div>
    <div class="forgot_details_card mat-elevation-z4" *ngIf="enterotp">
        <div class="forgot_details_code_card">
            <div class="forgot_details_header">Verification Code</div>
            <div class="forgot_details_header_details">Enter the code sent to your Email</div>
            <div style="text-align: center;">
                <div class="code_inputs">
                    <input type="text" maxlength="1" [(ngModel)]="code[0]" (keyup)="focusNext($event, 1)">
                    <input type="text" maxlength="1" [(ngModel)]="code[1]" (keyup)="focusNext($event, 2)">
                    <input type="text" maxlength="1" [(ngModel)]="code[2]" (keyup)="focusNext($event, 3)">
                    <input type="text" maxlength="1" [(ngModel)]="code[3]" (keyup)="focusNext($event, 4)">
                </div>
                <button class="forgot_button_details" (click)="verifyCode()">Verify</button>
            </div>
            <div style="text-align: center;padding: 15px 0px;color: var(--black-shade);font-family: var(--font);padding-bottom: 10px;font-size: 16px;">
                Didn't receive a code? <a href="#" class="resend_code" (click)="resendCode()">Resend code</a>
            </div>
        </div>
    </div>
    <div class="forgot_details_card mat-elevation-z4" *ngIf="changepassword">
        <div class="forgot_details_password_card">
            <div class="forgot_details_header"> Forgot Password ?</div>
            <div class="forgot_details_header_details">Create your new password here.</div>
            <div class="form_field">
                <div class="form_field">
                    <mat-form-field appearance="outline" class="forgot_form_fields">
                        <mat-label>Password</mat-label>
                        <input matInput placeholder="Enter Password" [type]="p_hide ? 'password' : 'text'"
                            [formControl]="Password">
                        <button mat-icon-button matSuffix (click)="p_hide = !p_hide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="p_hide">
                            <mat-icon style="color: var(--black-shade);">{{p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                        <mat-error *ngIf="!Password.valid">
                            {{getPasswordError()}}
                        </mat-error>
                    </mat-form-field>
                </div>
                
            </div>
            <div class="form_field">
                <mat-form-field appearance="outline" class="forgot_form_fields">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput placeholder="Confirm Password"  [type]="c_p_hide ? 'password' : 'text'"
                        [formControl]="ConfirmPassword">
                    <button class="eye_button" mat-icon-button matSuffix (click)="c_p_hide = !c_p_hide"
                        [attr.aria-label]="'Hide Confirm password'" [attr.aria-pressed]="c_p_hide">
                        <mat-icon style="color: var(--black-shade);">{{c_p_hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="!ConfirmPassword.valid">
                        {{getConfirmPasswordError()}}
                    </mat-error>
                </mat-form-field>
            </div>
            
            <div style="text-align: center;padding-bottom: 10px;">
                <button class="forgot_button_details">Confirm</button>
            </div>
        </div>
    </div>
</div>
<app-footer class="forgot_footer"></app-footer>